import { render, staticRenderFns } from "./GroupDashboardCard.vue?vue&type=template&id=30c1a14e&"
import script from "./GroupDashboardCard.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardCard.vue?vue&type=script&lang=js&"
import style0 from "./GroupDashboardCard.vue?vue&type=style&index=0&id=30c1a14e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports